import { useAppSelector } from "app/hooks";
import { Source } from "beitary-shared";
import {
  selectActiveOrganization,
  selectActiveUser,
} from "features/Authentication/AuthenticationSlice";
import { useEffect, useState } from "react";
import { DBService } from "services/db/DBService";
import { UnproperDBServiceArguments } from "./errors/UnproperDBServiceArguments";

/**
 * db needs organization id and user id as arguments
 * this hook is created to watch these ids and update
 * the service accordingly
 */

const recordSource: Source = "WEB";

export const useDBServices = () => {
  const organizationId = useAppSelector(selectActiveOrganization);
  const authUser = useAppSelector(selectActiveUser);

  if (!organizationId || !authUser || !authUser.uid || !authUser.displayName) {
    throw new UnproperDBServiceArguments();
  }

  const [service, setService] = useState(
    DBService(organizationId, authUser.uid, authUser.displayName, recordSource)
  );

  useEffect(() => {
    if (
      !organizationId ||
      !authUser ||
      !authUser.uid ||
      !authUser.displayName
    ) {
      throw new UnproperDBServiceArguments();
    }
    const authorId = authUser.uid;
    const updatedService = DBService(
      organizationId,
      authorId,
      authUser.displayName,
      recordSource
    );
    setService(updatedService);
  }, [organizationId, authUser]);

  return service;
};
